import { useEffect, useState } from 'react';
import { displayUserStore } from '@/dashboard/store/displayUserStore';
import { useAuthStore } from '@jove-frontend/uikit';
import { cloneDeep } from 'lodash';

export const useDisplayUserInfo = () => {
  const {
    state: { user },
  } = useAuthStore();
  const [displayUserInfo, setDisplayUserInfo] = useState<{ id: string; first_name: string; last_name: string; email: string }>();
  const {
    state: { userInfo },
  } = displayUserStore();

  /**
   * effects
   */
  useEffect(() => {
    setDisplayUserInfo(cloneDeep(!!userInfo ? userInfo : user));
  }, [user, userInfo]);

  return {
    displayUserInfo,
  };
};
